module.exports = __webpack_public_path__ + "static/media/vi.b219f68d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/vi.svg
// module id = 285
// module chunks = 0